import { render } from "./ShipPanel.vue?vue&type=template&id=f8634d30&ts=true"
import script from "./ShipPanel.vue?vue&type=script&lang=ts"
export * from "./ShipPanel.vue?vue&type=script&lang=ts"

import "./ShipPanel.vue?vue&type=style&index=0&id=f8634d30&lang=scss"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__